import { assertNever } from '../../../util';

import bearSvg from './bear.svg';
import boySvg from './boy.svg';
import dameSvg from './dame.svg';
import defaultSvg from './default.svg';
import dragonSvg from './dragon.svg';
import farmerSvg from './farmer.svg';
import farmeretteSvg from './farmerette.svg';
import foxSvg from './fox.svg';
import girlSvg from './girl.svg';
import kingSvg from './king.svg';
import knightSvg from './knight.svg';
import owlSvg from './owl.svg';
import queenSvg from './queen.svg';
import sheepSvg from './sheep.svg';
import sorcererSvg from './sorcerer.svg';
import sorceressSvg from './sorceress.svg';
import unicornSvg from './unicorn.svg';
import wolfSvg from './wolf.svg';

// used by SceneCanvas and SceneCanvasCharacterSelector
export enum CharacterIcon {
  BEAR = 'BEAR',
  BOY = 'BOY',
  DAME = 'DAME',
  DEFAULT = 'DEFAULT',
  DRAGON = 'DRAGON',
  FARMER = 'FARMER',
  FARMERETTE = 'FARMERETTE',
  FOX = 'FOX',
  GIRL = 'GIRL',
  KING = 'KING',
  KNIGHT = 'KNIGHT',
  OWL = 'OWL',
  QUEEN = 'QUEEN',
  SHEEP = 'SHEEP',
  SORCERER = 'SORCERER',
  SORCERESS = 'SORCERESS',
  UNICORN = 'UNICORN',
  WOLF = 'WOLF',
}

//
// mapCharacterIconToFilePath
// used by SceneCanvas and SceneCanvasCharacterSelector
//
// Mae, 06.05.2022 - issue with this function: in UI components, it works fine,
// but when using it as package, it returns the svg and not the path
//
// Mae, 13.06.2022 - when debugging issue PROD-1266, it turned out, that this functions
// returns also the image as PNG (returnValue something like "data:image/png;base64,iVBOR....")
// This leads to massive sizes of sessions that store these values.
// Nevertheless, this functions stays untouched and the issue is handled in
// the payload stored in the session.
//
export const mapCharacterIconToFilePath = (
  characterIcon: CharacterIcon
): string => {
  let returnValue;

  switch (characterIcon) {
    case CharacterIcon.BEAR:
      returnValue = bearSvg;
      break;
    case CharacterIcon.BOY:
      returnValue = boySvg;
      break;
    case CharacterIcon.DAME:
      returnValue = dameSvg;
      break;
    case CharacterIcon.DEFAULT:
      returnValue = defaultSvg;
      break;
    case CharacterIcon.DRAGON:
      returnValue = dragonSvg;
      break;
    case CharacterIcon.FARMER:
      returnValue = farmerSvg;
      break;
    case CharacterIcon.FARMERETTE:
      returnValue = farmeretteSvg;
      break;
    case CharacterIcon.FOX:
      returnValue = foxSvg;
      break;
    case CharacterIcon.GIRL:
      returnValue = girlSvg;
      break;
    case CharacterIcon.KING:
      returnValue = kingSvg;
      break;
    case CharacterIcon.KNIGHT:
      returnValue = knightSvg;
      break;
    case CharacterIcon.OWL:
      returnValue = owlSvg;
      break;
    case CharacterIcon.QUEEN:
      returnValue = queenSvg;
      break;
    case CharacterIcon.SHEEP:
      returnValue = sheepSvg;
      break;
    case CharacterIcon.SORCERER:
      returnValue = sorcererSvg;
      break;
    case CharacterIcon.SORCERESS:
      returnValue = sorceressSvg;
      break;
    case CharacterIcon.UNICORN:
      returnValue = unicornSvg;
      break;
    case CharacterIcon.WOLF:
      returnValue = wolfSvg;
      break;
    default:
      assertNever(characterIcon);
      break;
  }

  if (typeof returnValue === 'function') {
    const children = (returnValue as Function)().props.children;
    if (Array.isArray(children)) {
      const linkH = children.filter((child: any) => child.type === 'image');
      return linkH[0]?.props?.xlinkHref ?? '';
    } else {
      return children?.props?.xlinkHref ?? '';
    }
  } else {
    return returnValue;
  }

  /* return typeof returnValue === 'function'
    ? (returnValue as Function)().props.children.props.xlinkHref
    : returnValue; */
};
